module.exports = __webpack_public_path__ + "static/media/pdfIcon.cb2b85a1.svg";